module.exports = __webpack_public_path__ + "static/img/one-1.503a136.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/one-1.png
// module id = 0fGs
// module chunks = 1